import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  ProductLocationDto,
  ProductLocationReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import ProductLocationInline, { ProductLocationInlineProps } from "./ProductLocationInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity: ProductLocationDto | ProductLocationReferenceDto | null | undefined;
  entityId?: string | null;
  inlineProps?: Partial<ProductLocationInlineProps>;
}

export default function ProductLocationLink({
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.ProductLocationRead]}
      to={ROUTE_PATH.PRODUCT_SALES_LOCATION_VIEW(entity?.id || entityId || "")}
      content={<ProductLocationInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
